export default function Login({ submitLog }) {
  return (
    <div className="form">
      <p className="enter">ENTER YOUR USERNAME AND PASSWORD</p>
      <form onSubmit={submitLog}>
        <div className="formdata">
          <div>
            <p>USERNAME</p>
            <input type="text" name="userName"/>
          </div>
          <div>
            <p>PASSWORD</p>
            <input type="password" name="password"/>
          </div>
        </div>
        <input className="formsub" type="submit" />
      </form>
    </div>
  );
}
